import React, { useState } from "react";
import { ThreeColumnPage } from "../../Components/ThreeColumnPage";
import { NavigationNode } from "@aidkitorg/types/lib/translation/permissions";
import { useAsyncEffect } from "../../Hooks/AsyncEffect";
import { usePost } from "../../API";

export function AIPage(props: React.PropsWithChildren<{}>) {
  const [nav, setNav] = useState<NavigationNode[]>([]);

  const getNav = usePost('/program/admin/ai/navigation');

  useAsyncEffect(async () => {
    const result = await getNav({});
    if (result && Array.isArray(result.nav)) {
      setNav(result.nav);
    }
  }, [])

  return <ThreeColumnPage title="AI Admin" nav={nav} main={
    <div>
      {props.children}
    </div>} />
}